import { formatBytes, formatPercent, type StorageUsage } from '@moussenaires/shared';
import { useTranslation } from 'react-i18next';

import './StorageMeter.css';

export function StorageMeter({ usage }: { usage: StorageUsage }) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language as 'fr' | 'en';
  const percent = formatPercent(usage.ratio, locale);

  return (
    <div
      className={`storage-meter ${usage.isFull ? 'storage-meter-full' : usage.isWarning ? 'storage-meter-warning' : ''}`}
    >
      <div className="storage-meter-bar">
        <div
          className="storage-meter-fill"
          style={{ width: `${Math.min(100, usage.ratio * 100)}%` }}
        />
      </div>
      <span className="storage-meter-label">
        {t('admin.storageUsed', {
          used: formatBytes(usage.usedBytes, locale),
          limit: formatBytes(usage.limitBytes, locale),
          percent,
        })}
      </span>
    </div>
  );
}
